// Copyright (c) Ping. All rights reserved.

import type { ThreadSummary } from '../threads';

/**
 * Cycle 16 Wave 3 WEB-WIRE-B — pure helpers around `ThreadSummary`.
 *
 * These functions never touch the SDK, never log, and have no side
 * effects. They are split out from `MessageRowAdapter.tsx` so the
 * derivation rules can be exercised in unit tests without mounting a
 * React tree.
 */

/**
 * Returns the summary to render in the affordance, or `null` when the
 * row should suppress it. The affordance hides when there are zero
 * replies — a `replyCount === 0` summary is still a valid record
 * (e.g. the host might be eager-fetching threads for a sticky
 * preview), but the row UI does not render it.
 */
export function deriveThreadAffordance(
  summary: ThreadSummary | null | undefined,
): ThreadSummary | null {
  if (summary === null || summary === undefined) {
    return null;
  }
  if (summary.replyCount <= 0) {
    return null;
  }
  return summary;
}

/**
 * Pure derivation used by hosts that drive the unread badge on the
 * affordance separately from the `replyCount`.
 */
export function isThreadAffordanceHighlighted(
  summary: ThreadSummary | null | undefined,
): boolean {
  if (summary === null || summary === undefined) {
    return false;
  }
  return summary.unreadCount > 0;
}
